import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import InputSelect from "../../common/InputSelect";
/*BootstrapTable anbd table Related*/
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import TextField from "@material-ui/core/TextField";

/*Loader */
import FadeIn from "react-fade-in";

/*animation*/
import Loader from "../../common/loader/Loader";
/*Inputs*/
/*Styles*/
import "./ChangesByGame.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function FinalStatsByAgent(props) {
  let curr = new Date();
  let week = [];

  for (let i = 1; i <= 7; i++) {
    let first = curr.getDate() - curr.getDay() + i;
    let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
    week.push(day);
  }

  const classes = useStyles();
  const [stats, setStats] = React.useState([]);
  const [groupingID, setGroupingID] = useState();
  const [grouping, setGrouping] = useState();
  const [agentFrom, setAgentFrom] = useState("");
  const [distributor, setDistributor] = useState("");
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [isLoading, setIsLoading] = React.useState(true);
  const [bookID, setBookID] = useState();
  const [leagueId, setLeagueId] = useState();
  const [leagues, setLeagues] = useState();
  const [groupBy, setGroupBy] = useState(0);
  const [orderBy, setOrderBy] = useState(0);
  const [startDate, setStartDate] = React.useState(week[0]);
  const [endDate, setEndDate] = React.useState(week[0]);
  const [book, setBooks] = useState();
  // let IdPeriod = '0';

  const handleShow = () => { };

  useEffect(() => {
    //Change for server api address
    setIsLoading(true);
    const url = process.env.REACT_APP_API_URL + "/LEAGUE";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let leagueInfo = data.records.map((v) => {
          v.IdLineType = v.Description;
          v.Description = v.Description;
          return v;
        });
        setLeagues(leagueInfo);
        setIsLoading(false);
      });
  }, [setLeagues]);

  useEffect(() => {
    //Change for server api address
    setIsLoading(true);
    const url = process.env.REACT_APP_API_URL + "/OFFICE";

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let groupingInfo = data.records.map((v) => {
          v.IdLineType = v.OfficeName;
          v.Description = v.OfficeName;
          return v;
        });
        setGrouping(groupingInfo);
        setIsLoading(false);
      });
  }, [setGrouping]);

  const HistoryValues = () => {
    setIsLoading(true);
    let request = {
      logIdUser: userInfo.userId,
      StartDate: startDate,
      EndDate: endDate,
      Book: bookID ? bookID : "",
      Office: groupingID ? groupingID : "",
      Player: agentFrom,
      League: leagueId ? leagueId : "",
      GroupBy: groupBy,
      OrderBy: orderBy,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Reports/Report_Game_Statistic",
      //url: 'https://localhost:44337/api' + '/Reports/Report_Game_Statistic',
      data: request,
    }).then((response) => {
      console.log("response", response.data);
      setStats(response.data);
      setIsLoading(false);
    });
  };
  // const [selectedIdGame, setselectedIdGame] = useState();

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
  };

  const handleChangeStartDate = (event) => {
    setStartDate(event.target.value);
  };
  const handleChangeEndDate = (event) => {
    setEndDate(event.target.value);
  };
  const handleChangeAgentFrom = (event) => {
    setAgentFrom(event.target.value);
  };
  const hadleGroupByChange = (event) => {
    setGroupBy(event.target.value);
  };
  const hadleOrderByChange = (event) => {
    setOrderBy(event.target.value);
  };
  const handleChangeDistributor = (event) => {
    setDistributor(event.target.value);
  };

  /*Loader*/
  /**/

  function changeBookID(value) {
    setBookID({ value });
  }

  function changeGroupingID(value) {
    setGroupingID({ value });
  }

  function changeLeagueID(value) {
    setLeagueId({ value });
  }

  function rowClassNameFormat(row, rowIdx) {
    // row is whole row object
    // rowIdx is index of row
    return rowIdx % 2 === 0
      ? "tr-function-example"
      : "td-column-function-odd-example";
  }
  return (
    <React.Fragment>
      <div class="main-div">
        {isLoading ? (
          <FadeIn>
            <div class="d-flex justify-content-center align-items-center">
              <Loader height={360} width={360} />
            </div>
          </FadeIn>
        ) : (
          ""
        )}
        <div>
          <form className={classes.container} noValidate>
            <Table>
              <TableRow>
                <TableCell>
                  <TextField
                    id="startDate"
                    label="Start Date"
                    type="date"
                    defaultValue={startDate}
                    className={classes.textField}
                    onChange={handleChangeStartDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    id="endDate"
                    label="End Date"
                    type="date"
                    defaultValue={endDate}
                    className={classes.textField}
                    onChange={handleChangeEndDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <InputSelect
                    variant="outlined"
                    name="name"
                    data={book}
                    placeholder="Book"
                    setSelectValue={changeBookID}
                    startValue={bookID}
                  />
                </TableCell>
                <TableCell>
                  <InputSelect
                    variant="outlined"
                    name="name"
                    data={grouping}
                    placeholder="Office"
                    setSelectValue={changeGroupingID}
                    startValue={groupingID}
                  />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <TextField
                    type="text"
                    label="Player"
                    value={agentFrom}
                    multiline={true}
                    onChange={handleChangeAgentFrom}
                    variant="outlined"
                  />
                </TableCell>
                <TableCell>
                  <InputSelect
                    variant="outlined"
                    name="name"
                    data={leagues}
                    placeholder="Line Types"
                    setSelectValue={changeLeagueID}
                    startValue={leagueId}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <h6>Group By</h6>
                  <RadioGroup row>
                    <FormControlLabel
                      // value="None"
                      control={
                        <Radio
                          checked={groupBy == "0"}
                          onChange={hadleGroupByChange}
                          value="0"
                          label="None"
                          name="radio-button-time"
                          inputProps={{ "aria-label": "None" }}
                        //disabled
                        />
                      }
                      label="None"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      //   value="Home"
                      control={
                        <Radio
                          checked={groupBy == "1"}
                          onChange={hadleGroupByChange}
                          value="1"
                          label="Office"
                          name="radio-button-time"
                          inputProps={{ "aria-label": "Home" }}
                        // disabled
                        />
                      }
                      label="Office"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      //  value="Visitor"
                      control={
                        <Radio
                          checked={groupBy == "2"}
                          onChange={hadleGroupByChange}
                          value="2"
                          label="Player"
                          name="radio-button-time"
                          inputProps={{ "aria-label": "Visitor" }}
                        // disabled
                        />
                      }
                      label="Player"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <h6>Order By</h6>
                  <RadioGroup row>
                    <FormControlLabel
                      // value="None"
                      control={
                        <Radio
                          checked={groupBy == "0"}
                          onChange={hadleOrderByChange}
                          value="0"
                          label="Sport"
                          name="radio-button-time"
                          inputProps={{ "aria-label": "None" }}
                        //disabled
                        />
                      }
                      label="Sport"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      //   value="Home"
                      control={
                        <Radio
                          checked={groupBy == "1"}
                          onChange={hadleOrderByChange}
                          value="1"
                          label="Bet Type"
                          name="radio-button-time"
                          inputProps={{ "aria-label": "Home" }}
                        // disabled
                        />
                      }
                      label="BetType"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      //  value="Visitor"
                      control={
                        <Radio
                          checked={groupBy == "2"}
                          onChange={hadleOrderByChange}
                          value="2"
                          label="Period"
                          name="radio-button-time"
                          inputProps={{ "aria-label": "Visitor" }}
                        // disabled
                        />
                      }
                      label="Period"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      //  value="Visitor"
                      control={
                        <Radio
                          checked={groupBy == "2"}
                          onChange={hadleOrderByChange}
                          value="2"
                          label="Play"
                          name="radio-button-time"
                          inputProps={{ "aria-label": "Visitor" }}
                        // disabled
                        />
                      }
                      label="Play"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Button color="inherit" onClick={HistoryValues}>
                    Show
                  </Button>
                </TableCell>
              </TableRow>
            </Table>
          </form>
          <div>
            <br />
            <Table>
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell className={classes.headerCell}>
                    <strong>Sport</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Bet Type</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Period</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Play</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Risked</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Win/Loss</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Hold %</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              {stats &&
                stats.map((row) => (
                  <TableRow>
                    <TableCell colSpan={1} style={{ verticalAlign: "top" }}>
                      {row.IdSport}
                    </TableCell>
                    <TableCell colSpan={13}>
                      {row.WagerTypeList.map((row2) => (
                        <Table style={{ width: "100%" }}>
                          <TableRow>
                            <TableCell
                              style={{ width: "20%", verticalAlign: "top" }}
                              colSpan={5}
                            >
                              {row2.WagerType}
                            </TableCell>
                            <TableCell colSpan={9}>
                              {row2.PeriodList.map((row3) => (
                                <Table>
                                  <TableRow>
                                    <TableCell style={{ width: "20%" }}>
                                      {row3.Period}
                                    </TableCell>

                                    <TableCell style={{ width: "12%" }}>
                                      {row3.Play}
                                    </TableCell>

                                    <TableCell style={{ width: "20%" }}>
                                      {row3.Risk}
                                    </TableCell>

                                    <TableCell style={{ width: "28%" }}>
                                      {row3.WinLoss}
                                    </TableCell>
                                    <TableCell>{row3.HoldPerct}</TableCell>
                                  </TableRow>
                                </Table>
                              ))}
                            </TableCell>
                          </TableRow>
                        </Table>
                      ))}
                    </TableCell>
                  </TableRow>
                ))}
            </Table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
